const DocumentVariableGroupKeys = Object.freeze({
  SPECIAL: 'SPECIAL',
  DECEASED: 'DECEASED',
  DOSSIER: 'DOSSIER',
  DATE: 'DATE',
  INVOICE: 'INVOICE',
  INVOICE_EXPORT_FIELDS: 'INVOICE_EXPORT_FIELDS',
  EVENT: 'EVENT',
  GENERIC_EVENT: 'GENERIC_EVENT',
  USER: 'USER',
  APP: 'APP',
  FUNERAL_HOME: 'COMPANY',
  INVOICE_ITEM: 'INVOICE_ITEM',
  INVOICE_FOR_ITEMS: 'INVOICE_FOR_ITEMS',
  DOSSIER_FOR_ITEMS: 'DOSSIER_FOR_ITEMS',
  DOSSIER_FOR_INVOICE: 'DOSSIER_FOR_INVOICE',
  EVENT_FOR_ITEMS: 'EVENT_FOR_ITEMS',
  EVENT_FOR_INVOICE: 'EVENT_FOR_INVOICE',
  THIRD_PARTY_COST_PAYMENT: 'THIRD_PARTY_COST_PAYMENT'
})

export default DocumentVariableGroupKeys
